import { render, staticRenderFns } from "./ClientOrderView.vue?vue&type=template&id=f8cede4a&scoped=true&"
import script from "./ClientOrderView.vue?vue&type=script&lang=js&"
export * from "./ClientOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cede4a",
  null
  
)

export default component.exports